import { render, staticRenderFns } from "./KernelBoxTypeEditor.vue?vue&type=template&id=89a622d8&"
import script from "./KernelBoxTypeEditor.vue?vue&type=script&lang=js&"
export * from "./KernelBoxTypeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports